import * as React from "react"
import { ModuleLoading } from "@digits-shared/components/Loaders"
import { RequestScheme } from "@digits-shared/hooks/useMagicLinkToken"
import colors from "@digits-shared/themes/colors"
import styled from "styled-components"
import { useMagicLinkLogIn } from "src/frontend/components/Public/hooks/useMagicLinkLogIn"
import { Logo } from "src/frontend/components/Public/Shared/shared"
import { slide } from "src/frontend/components/Shared/Glow/animations"
import { AnimatedWrapper, Biscuit } from "src/frontend/components/Shared/Glow/Biscuit"

/*
  STYLES
*/

const Center = styled.div`
  text-align: center;
`

const StyledLogo = styled(Logo)`
  background: ${colors.secondaryDark};
  padding: 16px;
  border-radius: 50%;
`

/*
  COMPONENTS
*/

export const MagicLinkLoading: React.FC = () => {
  // attempt to exchange a magic link for a session if query param is found on the URL
  const { scheme, loading } = useMagicLinkLogIn()
  if (!loading && scheme === RequestScheme.Digits) {
    return (
      <AnimatedWrapper variants={slide} initial="initial" animate="animate">
        <Biscuit>
          <StyledLogo />
          <Center>It is now safe to close this window.</Center>
        </Biscuit>
      </AnimatedWrapper>
    )
  }

  return <ModuleLoading />
}
